/**
 * A type guard that checks if a value is defined
 *
 * @param x The value to check against
 * @returns {boolean} True if the value is defined
 */
export function isDefined<T>(x: T | undefined): x is T {
	return x !== undefined;
}
